












































import Vue from 'vue';

export default Vue.extend({
  name: 'ConfirmEmailNotification',
  props: {
    email: {
      type: String,
      required: true
    }
  },
  computed: {
    isSideBarMini(): boolean {
      return this.$store.state.sideBarMini;
    }
  },
  methods: {
    resendEmail() {
      this.$emit('resendEmail');
    }
  }
});
